import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import { Helmet } from "react-helmet"
import Appbar from "../components/appbar"
import Prism from 'prismjs'
import Tags from '../components/tags'
import "github-markdown-css/github-markdown.css"
import "prismjs/themes/prism-okaidia.css"
import "../blog.css"
import SEO from "../components/SEO"

let randomColors = ["#27fb6b", "#0adbcd", "#ff2e63", "#f1e05a"]
const Template = (props) => {
    // console.log(props)
    // return (
    //     <h1>Works!</h1>
    // )
    const title = props.data.markdownRemark.frontmatter.title
    const date = props.data.markdownRemark.frontmatter.date
    const tags = props.data.markdownRemark.frontmatter.tags

    const html = props.data.markdownRemark.html
    useEffect(() => {
      Prism.highlightAll();
    })
    return (
        <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{title} | Kaustubh</title>
        </Helmet>
        <SEO title={`${title} | Kaustubh`} />
        <Appbar />
        <div className="blog-container">
            <div className="text-center">
              <h1 className="">{title}</h1>
              <p className="">Published on {date}</p>
              <p className=""><Tags content={tags} glow={false} randomColors={randomColors} /></p>
            </div>
            <div className="markdown-body" dangerouslySetInnerHTML={{__html: html}}></div>
        </div>
        </div>
    )
}

export const query = graphql`
  query($pathSlug: String) {
    markdownRemark(frontmatter: { path: {eq: $pathSlug} }) {
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        tags
      }
    }
  }
`

export default Template
